/* eslint-disable no-undef */
import cookies from 'js-cookie';
import { io } from 'socket.io-client';
import { getAuthToken } from './helper/authHelper';

export const socketIO = io(`${process.env.REACT_APP_NOTIFICATION_ENDPOINT}`, {
  extraHeaders: {
    userId: cookies.get('userId'),
    loginId: cookies.get('email'),
    authToken: getAuthToken(),
  },
});
